import { PreWraper } from '@components/shared/wraper/PreWraper'

export const ProgramRequestOfferHeading = (): JSX.Element => (
  <div className="md:text-[1.6vw] font-bold md:leading-[2.5vw]">
    <PreWraper text={`プログラムリクエストは\nこちらから！`} />
  </div>
)
